import React from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import reducer from "./config/reducers/index.reducer";
import thunk from "redux-thunk";
import { ConfigProvider, theme } from "antd";
import setUpInterceptors from "./config/services/http.service";

const store = createStore(reducer, applyMiddleware(thunk));
const container = document.getElementById("root");
const root = createRoot(container);
setUpInterceptors();

root.render(
  <Provider store={store}>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1890ff",
          colorWarning: "#faad14",
          algorithm: theme.darkAlgorithm,
          fontFamily: "Roboto",
        },
      }}
      componentSize="small"
    >
      <App />
    </ConfigProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
